import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';
import { AuditLogsRouteNames } from '@/modules/core/auditlog/auditlog.constants';

export const router = PageRouteConfig.factory(
  [
    {
      path: `/${AuditLogsRouteNames.AUDIT_LOGS}/:type?/:id?`,
      name: AuditLogsRouteNames.AUDIT_LOGS,
      component: () => import(/* webpackChunkName: "auditlogs-page" */ './pages/AuditlogsPage.vue'),
    },
  ],
  Module.AUDITLOG
);
